import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { SectionContainer } from "../layout";
import {
  transformLink,
  isLinkRelative,
  SmartLink,
  localizeDateTime,
} from "../../utils";
import { t } from "../../translations";
import { lightBackgroundColor } from "../../constants";
import pressKitIcon from "../../images/kit-presse.svg";

const formatUrl = href => {
  const transformedLink = transformLink(href);
  if (isLinkRelative(transformedLink)) {
    return transformedLink.split("/").pop();
  }
  return href;
};

export const PressListing = ({
  locale,
  backgroundColor = lightBackgroundColor,
  pressKitUrl,
}) => {
  const { allSanityPresse } = useStaticQuery(graphql`
    query PressListingQuery {
      allSanityPresse(sort: { fields: publishedAt, order: DESC }) {
        nodes {
          id
          title
          link
          category
          publishedAt
          locale
        }
      }
    }
  `);
  const posts = allSanityPresse.nodes.filter(post => post.locale === locale);

  return (
    <SectionContainer
      className={backgroundColor}
      title={t(locale, "press.title")}
    >
      <div className="max-w-6xl mx-auto lg:grid lg:gap-16 lg:grid-cols-3 lg:gap-x-16 lg:gap-y-12">
        <div className="lg:mt-10 mb-10 lg:col-span-1 text-center lg:order-last">
          <a href={pressKitUrl} target="_blank" rel="noopener noreferrer">
            <div className="flex flex-col rounded-lg shadow-lg overflow-hidden px-12 py-6 bg-action-100">
              <div className="flex-1 bg-action-100 p-6 flex flex-col justify-between text-center">
                <div className="flex-1">
                  <p className="text-xl font-semibold text-gray-900">
                    {t(locale, "press.kit")}
                  </p>
                  <p className="mt-3 text-base text-gray-500">
                    {t(locale, "press.download-kit")}
                  </p>
                </div>
                <div className="flex-shrink-0 flex mx-auto my-auto items-center justify-center h-22 w-22 rounded-md bg-action-100 text-action-500 sm:h-24 sm:w-24">
                  <img
                    src={pressKitIcon}
                    className="h-14 w-14"
                    aria-hidden="true"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </a>
        </div>
        <div className="lg:col-span-2">
          {posts.map(post => {
            const { title, link, publishedAt, category, id } = post;
            return (
              <article className="max-w-3xl mx-auto py-8 bg-white" key={id}>
                <SmartLink href={link}>
                  <div className="mb-2">
                    <span className="text-gray-500">
                      {localizeDateTime(publishedAt, locale)}
                    </span>
                    <span className="font-hairline ml-4 mr-1">#</span>
                    <span className="text-gray-900">
                      {category === "press"
                        ? t(locale, "press.category-press")
                        : t(locale, "press.category-communique")}
                    </span>
                  </div>
                  <div className="text-xl font-semibold text-gray-900 my-2">
                    {title}
                  </div>
                  <div className="hover:underline text-action truncate">
                    {formatUrl(link)}
                  </div>
                </SmartLink>
              </article>
            );
          })}
        </div>
      </div>
    </SectionContainer>
  );
};
